import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=dce207e6&scoped=true&"
import script from "./Callout.vue?vue&type=script&lang=ts&"
export * from "./Callout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce207e6",
  null
  
)

export default component.exports